// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"pressHeader-module--headerWrapper--2DHEb","headerContainer":"pressHeader-module--headerContainer--3dpJn"};